<div class="text-center" [ngStyle]="{'margin': margin}">
    <div class="spinner-border" [ngStyle]="{'width': size, 'height': size}" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>